import { useQuery } from 'react-query';
import { queryGet } from '../../../utils/queryClient';
import type { ArtistType } from '../../types/ArtistType';

interface ArtistResponse {
  artists: ArtistType[];
}

export default function useArtistQueryLikedOnly() {
  return useQuery<ArtistResponse, Error, ArtistType[]>(
    ['likedArtist'],
    () => queryGet('/api/v1/artists?liked_only=true&page=1&per_page=10000'),
    {
      select: (data: ArtistResponse) => data.artists
    }
  );
}
